import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Helper function to generate a visitor ID
const generateVisitorId = () => {
  // Check if a visitor ID already exists in local storage
  let visitorId = localStorage.getItem('visitor_id');
  
  // If not, create a new one
  if (!visitorId) {
    visitorId = 'visitor_' + Math.random().toString(36).substring(2, 15);
    localStorage.setItem('visitor_id', visitorId);
  }
  
  return visitorId;
};

const VisitTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Function to record the page visit
    const recordVisit = async () => {
      try {
        const path = location.pathname;
        const visitorId = generateVisitorId();
        
        await fetch('/api/stats/record-visit', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ path, visitorId }),
        });
        
        // No need to process the response, just record the visit
      } catch (error) {
        console.error('Error recording visit:', error);
        // Silently fail to not disrupt user experience
      }
    };
    
    // Record the visit when the path changes
    recordVisit();
  }, [location.pathname]);
  
  // This component doesn't render anything
  return null;
};

export default VisitTracker;